<template>
  <v-app>
    <v-container class="pa-0">
      <v-row
        class="banner"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-responsive :aspect-ratio="1065/531">
            <v-img :src="service.image" class="rounded-b-xl"/>
          </v-responsive>
        </v-col>
      </v-row>
      <v-row
        class="mt-n16"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-card
            class="mx-10"
            rounded="xl"
            elevation="8"
            v-if="detail.status === 'BOOKED' || detail.status === 'PENDING_CONFIRM'"
          >
            <v-card-text
              class="text-center"
            >
              <div
                class="d-flex justify-center my-4"
              >
                <v-avatar size="100">
                  <v-img :src="brand.logo"/>
                </v-avatar>
              </div>
              <div
                class="mb-4 text-caption font-weight-bold"
                :class="detail.status === 'PENDING_CONFIRM' ? 'orange--text' : 'pink--text'"
              >{{ detail.status === 'PENDING_CONFIRM' ? '等待店家確認' : '成功預約' }}</div>
              <div class="text-body-1 grey--text text--darken-4 font-weight-bold">
                {{ brand.name }} - {{ store.name }}
              </div>
              <div class="text-h6 grey--text text--darken-4 font-weight-bold">
                {{ service.name }}
              </div>
              <div class="text-body-1 mb-2">
                {{ detail.name }}・{{ formattedCell }}
              </div>
              <div class="text-body-2" v-if="detail.staff">
                服務人員 {{ detail.staff }}
              </div>
              <div class="text-body-2">
                {{ detail.date | moment('YYYY/M/D (ddd)') }} {{ detail.time }}・{{ detail.amount }} 位
              </div>
              <div
                v-if="canAddToCalendar"
                class="mt-6 mb-2"
              >
                <v-btn
                  id="calendar-primary"
                  color="pink"
                  outlined
                  rounded
                  large
                  :loading="calendarLoading === 'primary'"
                  v-on:click="addToCalendar('primary', $event)"
                >
                  <v-icon left>mdi-calendar-plus</v-icon>
                  加入行事曆
                </v-btn>
                <div v-if="calendarOptions.other.length && !platform.inAppBrowser">
                  <v-btn
                    id="calendar-other"
                    class="mt-1"
                    color="grey darken-1"
                    text
                    small
                    rounded
                    :loading="calendarLoading === 'other'"
                    v-on:click="addToCalendar('other', $event)"
                  >
                    使用其他行事曆
                  </v-btn>
                </div>
              </div>
              <div
                v-if="detail.status === 'PENDING_CONFIRM'"
                class="my-8 px-4 py-6 rounded-xl orange lighten-5 orange--text text--darken-2"
              >
                <div class="font-weight-bold">
                  <v-icon color="orange darken-2" class="mr-2" small>mdi-clock-outline</v-icon>
                  已收到您的預約，等待店家確認中
                </div>
                <div class="mt-2 text-body-2">店家確認後將另行通知您</div>
              </div>
              <template v-if="detail.need_to_confirm">
                <div class="my-8 px-4 py-6 rounded-xl pink lighten-5 pink--text">
                  <div class="font-weight-bold">正在等待您的確認，請問您是否如期赴約？</div>
                  <div class="mt-4 my-2">
                    <v-btn
                      class="white--text"
                      color="pink"
                      rounded
                      depressed
                      large
                      v-on:click="confirmBook"
                    >
                      <v-icon left>mdi-check-all</v-icon>
                      我會赴約
                    </v-btn>
                  </div>
                  <div>
                    <v-btn
                      class="pink--text"
                      color="white"
                      rounded
                      depressed
                      v-on:click="showCancelModal = true"
                    >
                      <v-icon left>mdi-cancel</v-icon>
                      取消預約
                    </v-btn>
                  </div>
                </div>
              </template>
              <div
                class="d-flex justify-center my-4"
              >
                <v-btn
                  depressed
                  rounded
                  :href="`tel:${store.tel}`"
                  class="mr-2"
                >
                  <v-icon left>mdi-phone</v-icon>
                  撥打電話
                </v-btn>
                <v-btn
                  depressed
                  rounded
                  :href="`https://maps.google.com/?q=${store.address}`"
                  target="_blank"
                >
                  <v-icon left>mdi-map-marker</v-icon>
                  地圖
                </v-btn>
              </div>
              <div>
                <v-btn
                  rounded
                  depressed
                  v-on:click="showCancelModal = true"
                >
                  <v-icon left>mdi-cancel</v-icon>
                  取消此預約
                </v-btn>
              </div>
            </v-card-text>

            <v-card-text
              v-if="service.reminder"
            >
              <div
                class="mb-4 text-caption pink--text font-weight-bold"
              >{{ service.name }} 服務須知</div>
              <div
                class="mt-4 text-body-2 grey--text text--darken-1"
              >
                <vue-markdown :source="service.reminder" :options="{ linkify: true }"/>
              </div>
            </v-card-text>
          </v-card>

          <v-card
            class="mx-10"
            rounded="xl"
            elevation="8"
            v-if="detail.status === 'CANCELED_ONLINE'"
          >
            <v-card-text
              class="text-center"
            >
              <div
                class="d-flex justify-center my-4"
              >
                <v-avatar size="100">
                  <v-img :src="brand.logo"/>
                </v-avatar>
              </div>
              <div class="my-8 px-4 py-6 rounded-xl pink lighten-5 pink--text">
                <div class="font-weight-bold">
                  <v-icon color="pink" class="mr-2" small>mdi-alert</v-icon>
                  預約已經取消
                </div>
                <div class="mt-4 my-2">
                  <v-btn
                    class="white--text"
                    color="pink"
                    rounded
                    depressed
                    large
                    :to="`/${brand.id}/${store.id}`"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    再次預約
                  </v-btn>
                </div>
              </div>
              <div class="text-body-1 grey--text text--darken-4 font-weight-bold">
                {{ brand.name }} - {{ store.name }}
              </div>
              <div class="text-h6 grey--text text--darken-4 font-weight-bold">
                {{ service.name }}
              </div>
              <div class="text-body-1">
                {{ detail.name }}・{{ formattedCell }}
              </div>
              <div class="text-body-2">
                {{ detail.date | moment('YYYY/M/D (ddd)') }} {{ detail.time }}・{{ detail.amount }} 位
              </div>
              <div
                class="d-flex justify-center my-4"
              >
                <v-btn
                  depressed
                  rounded
                  :href="`tel:${store.tel}`"
                  class="mr-2"
                >
                  <v-icon left>mdi-phone</v-icon>
                  撥打電話
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <div class="my-4 text-center text-caption text--secondary">
            bookNow.tw ©️ All Rights Reserved.<br>
            <span v-if="brand.name">{{ brand.name }}</span>
            <span v-else>品牌</span>
            保留接受或拒絕預訂之權力
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="showCancelModal"
      width="500"
    >
      <v-card
        rounded="lg"
      >
        <v-card-title class="text-h6">是否要取消預約？</v-card-title>

        <v-form
          class="px-6"
          v-model="cancelValid"
          v-if="service.cancel_reason.length"
        >
          <v-container class="px-0">
            <v-row dense>
              <v-col>
                <v-select
                  :items="service.cancel_reason"
                  item-color="pink"
                  v-model="selectedCancelReason"
                  label="取消原因"
                  placeholder="請選擇"
                  color="pink"
                  hide-details
                  outlined
                  :rules="[value => !!value || '請選擇']"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-card-text>提醒您，取消後即無法還原</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="pink"
            text
            v-on:click="showCancelModal = false"
            rounded
          >
            保留預約
          </v-btn>
          <v-btn
            color="pink"
            text
            v-on:click="cancelBook"
            rounded
            :disabled="service.cancel_reason.length > 0 && !cancelValid"
          >
            取消預約
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showInAppBrowserDialog"
      width="500"
    >
      <v-card
        ref="inAppBrowserCard"
        rounded="lg"
      >
        <v-card-title class="text-h6">請改用瀏覽器開啟</v-card-title>
        <v-card-text>
          <p>{{ platform.isLine ? 'LINE' : 'App' }} 內建的瀏覽器無法加入行事曆。請點畫面上的「⋯」選單改用瀏覽器開啟，或複製下方連結貼到 Safari、Chrome，再按一次「加入行事曆」。</p>
          <v-text-field
            id="calendar-page-url"
            :value="pageUrl"
            color="pink"
            readonly
            outlined
            dense
            hide-details
            v-on:focus="$event.target.select()"
          ></v-text-field>
          <div
            v-if="pageUrlCopyFailed"
            class="mt-2 text-caption"
          >無法自動複製，請長按上方網址手動複製。</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="pink"
            text
            rounded
            v-on:click="showInAppBrowserDialog = false"
          >
            關閉
          </v-btn>
          <v-btn
            color="pink"
            text
            rounded
            v-on:click="copyPageUrl"
          >
            {{ pageUrlCopied ? '已複製' : '複製連結' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showCalendarFallback"
      width="500"
    >
      <v-card
        v-if="calendar"
        rounded="lg"
      >
        <v-card-title class="text-h6">行事曆選單暫時打不開</v-card-title>
        <v-card-text>請直接選擇要加入的行事曆：</v-card-text>
        <v-card-actions class="flex-wrap">
          <v-btn
            class="text-none"
            color="pink"
            text
            rounded
            :href="googleCalendarUrl"
            target="_blank"
            v-on:click="showCalendarFallback = false"
          >
            Google 日曆
          </v-btn>
          <v-btn
            class="text-none"
            color="pink"
            text
            rounded
            :href="icsUrl"
            v-on:click="showCalendarFallback = false"
          >
            Apple／Outlook 行事曆
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            rounded
            v-on:click="showCalendarFallback = false"
          >
            關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Axios from '@/helpers/axios';
import VueMarkdown from 'vue-markdown-render';
import PhoneNumber from 'awesome-phonenumber';
import { initTracking, trackEvent, EVENTS } from '@/helpers/tracking';
import {
  detectPlatform, calendarOptions, isUpcoming, icsUrl, googleCalendarUrl, googleCalendarIntent,
  openCalendarList,
} from '@/helpers/calendar';

export default {
  name: 'Booked',
  components: {
    VueMarkdown,
  },
  beforeMount() {
    const data = {
      token: this.$route.params.bookId,
    };

    Axios({
      method: 'POST',
      url: 'get',
      data,
    })
      .then((api) => {
        if (api.status === 200) {
          this.brand = api.data.brand;
          this.store = api.data.store;
          this.detail = api.data.detail;
          this.service = api.data.service;
          // 後端還沒上線時沒有 calendar，按鈕就不顯示
          this.calendar = api.data.calendar || null;

          initTracking(api.data.tracking);
        }
      });
  },
  data() {
    return {
      brand: {
        name: '',
        logo: '',
        image: '',
      },

      store: {
        token: '',
        name: '',
        image: '',
        address: '',
        tel: '',
      },

      detail: {
        amount: 0,
        date: '',
        time: '',
        name: '',
        contact: '',
        status: 'BOOKED',
      },

      service: {
        image: '',
        name: '',
        reminder: '',
        cancel_reason: [],
      },

      // 加入行事曆的事件內容，由後端組好：title, description, location, url, start, end, timezone
      calendar: null,

      selectedCancelReason: null,
      cancelValid: false,
      showCancelModal: false,

      platform: detectPlatform(),
      // 'primary' / 'other'：哪顆按鈕正在載入清單
      calendarLoading: null,
      lastCalendarClick: 0,
      showCalendarFallback: false,
      showInAppBrowserDialog: false,
      pageUrlCopied: false,
      pageUrlCopyFailed: false,
    };
  },
  computed: {
    // 待店家確認、已取消、已過預約時間都不顯示，避免行事曆留下不會發生的行程
    canAddToCalendar() {
      return this.detail.status === 'BOOKED' && !!this.calendar && isUpcoming(this.calendar);
    },
    calendarOptions() {
      return calendarOptions(this.platform);
    },
    icsUrl() {
      return icsUrl(this.$route.params.bookId);
    },
    googleCalendarUrl() {
      return this.calendar ? googleCalendarUrl(this.calendar) : '';
    },
    // 內建瀏覽器提示裡的網址，不帶 query string
    pageUrl() {
      return `${window.location.origin}${this.$route.path}`;
    },
    formattedCell() {
      if (this.detail.contact === '') return '';

      // 後端已轉本地格式並遮蔽（0912***678），直接顯示
      if (this.detail.contact.indexOf('*') !== -1) return this.detail.contact;

      return new PhoneNumber(this.detail.contact, 'TW').getNumber('national');
    },
  },
  methods: {
    async addToCalendar(type, event) {
      // 連點會開兩次，1.5 秒內的重複點擊直接忽略
      const now = Date.now();
      if (this.calendarLoading || now - this.lastCalendarClick < 1500) return;
      this.lastCalendarClick = now;

      const track = (method) => trackEvent(EVENTS.ADD_TO_CALENDAR, {
        ga: { transaction_id: this.$route.params.bookId, method },
      });

      if (this.platform.inAppBrowser) {
        track('in_app_browser');
        this.pageUrlCopied = false;
        this.pageUrlCopyFailed = false;
        this.showInAppBrowserDialog = true;
        return;
      }

      // 手機主按鈕：在點擊當下同步開啟，不經過套件
      if (type === 'primary' && this.platform.isIOS) {
        track('apple');
        window.location.href = this.icsUrl;
        return;
      }
      if (type === 'primary' && this.platform.isAndroid) {
        track('google');
        window.open(googleCalendarIntent(this.calendar), '_blank');
        return;
      }

      // 電腦清單與手機「使用其他行事曆」：載入套件顯示清單，失敗就改給直接的連結
      // 電腦按主按鈕用 list，手機點「使用其他行事曆」用 other；GA 的 method 也用同一個值
      const listType = type === 'other' ? 'other' : 'list';
      const trigger = event.currentTarget;
      this.calendarLoading = type;
      try {
        await openCalendarList(this.calendar, this.$route.params.bookId, this.calendarOptions[listType], trigger);
        track(listType);
      } catch (e) {
        track('failed');
        this.showCalendarFallback = true;
      } finally {
        this.calendarLoading = null;
      }
    },
    async copyPageUrl() {
      this.pageUrlCopyFailed = false;
      try {
        await navigator.clipboard.writeText(this.pageUrl);
        this.pageUrlCopied = true;
        return;
      } catch (e) {
        // 內建瀏覽器常常不給用 Clipboard API，往下改用 execCommand
      }

      // iOS 對 readonly 的 input 選不到文字，另外放一個可編輯的 textarea 來複製；
      // 放在 dialog 裡面，避免 Vuetify dialog 的 focus trap 把焦點搶回去
      const container = this.$refs.inAppBrowserCard && this.$refs.inAppBrowserCard.$el;
      if (!container) {
        this.pageUrlCopyFailed = true;
        return;
      }
      const textarea = document.createElement('textarea');
      textarea.value = this.pageUrl;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      container.appendChild(textarea);
      textarea.focus();
      textarea.setSelectionRange(0, textarea.value.length);
      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (e) {
        copied = false;
      }
      container.removeChild(textarea);

      this.pageUrlCopied = copied;
      this.pageUrlCopyFailed = !copied;
    },
    cancelBook() {
      const data = {
        token: this.$route.params.bookId,
      };

      if (this.selectedCancelReason) data.cancel_reason = this.selectedCancelReason;

      Axios({
        method: 'POST',
        url: 'cancel',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            trackEvent(EVENTS.BOOK_CANCEL, {
              ga: { transaction_id: this.$route.params.bookId },
            });

            window.location.reload();
          }
        });
    },
    confirmBook() {
      const data = {
        token: this.$route.params.bookId,
      };

      Axios({
        method: 'POST',
        url: 'confirm',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            trackEvent(EVENTS.BOOK_CONFIRM, {
              ga: { transaction_id: this.$route.params.bookId },
            });

            window.location.reload();
          }
        });
    },
  },
  watch: {
    showCancelModal(val) {
      if (val === false) this.selectedCancelReason = null; this.cancelValid = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.banner
  position: sticky
  top: 0
</style>
